import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import { handleErrorMsg, getSelectedLanguageContent, capitalizeFirstLetter } from 'utils'
import { Get, Post, Put, DownloadFile } from 'utils/axios'
import { storeItem } from 'utils/tokenStore'
import { requestError, requestSuccess } from 'utils/requestHandler'
import { addLoadingContent, removeLoadingContent } from 'reducers/LoadingOverlay'
import { convertObjectToBase64 } from 'utils/objToBase64'
import { getNextRank } from 'utils/rank'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      pendingUsersCount: 0,
      pendingMembersCount: 0,
      pendingCustomersCount: 0,
      pendingSellersCount: 0,
      pendingProductsCount: 0,
      pendingWithdrawalCount: 0,
      pendingComplaintCount: 0,
      packingInProgressCount: 0
    }

    load = param => {
      if( param ){
        this.props.addLoadingContent()
      } else {
        this.props.removeLoadingContent()
      }
    }

    onChangeHOC = ( key, val ) => this.setState({ [ key ]: val })

    getPendingMembers = (query) => Get(
      `/clients/${ this.props.clientInfo.id }/client_users?query=${convertObjectToBase64(query)}`,
      this.getPendingMembersSuccess,
      this.getPendingMembersError,
      this.load
    )
    getPendingMembersSuccess = payload => this.setState({
      pendingMembersCount: payload.meta.totalCount,
    })
    getPendingMembersError = (error) => requestError(handleErrorMsg(error))

    getPendingCustomers = (query) => Get(
      `/clients/${ this.props.clientInfo.id }/client_users?query=${convertObjectToBase64(query)}`,
      this.getPendingCustomersSuccess,
      this.getPendingCustomersError,
      this.load
    )
    getPendingCustomersSuccess = payload => this.setState({
      pendingCustomersCount: payload.meta.totalCount,
    })
    getPendingCustomersError = (error) => requestError(handleErrorMsg(error))

    getPendingSellers = (query) => Get(
      `/clients/${ this.props.clientInfo.id }/client_users?query=${convertObjectToBase64(query)}`,
      this.getPendingSellersSuccess,
      this.getPendingSellersError,
      this.load
    )
    getPendingSellersSuccess = payload => this.setState({
      pendingSellersCount: payload.meta.totalCount,
    })
    getPendingSellersError = (error) => requestError(handleErrorMsg(error))

    getPendingProducts = (query) => {
      Get(
        `/sites/${this.props.siteInfo.id}/products?query=${convertObjectToBase64(query)}`,
        this.getPendingProductsSuccess,
        this.getPendingProductsError,
        this.load
      )
    }
    getPendingProductsSuccess = payload => this.setState({ pendingProductsCount: payload.meta.totalCount })
    getPendingProductsError = (error) => requestError(handleErrorMsg(error))

    getPendingWithdrawal = (query) => Get(
      `/sites/${ this.props.siteInfo.id }/all_wallet_withdraw_logs?query=${convertObjectToBase64(query)}`,
      this.getPendingWithdrawalSuccess,
      this.getPendingWithdrawalError,
      this.load
    )
    getPendingWithdrawalSuccess = payload => this.setState({ pendingWithdrawalCount: payload.length })
    getPendingWithdrawalError = (error) => requestError(handleErrorMsg(error))

    getComplaints = (query) => Get(
      `/sites/${ this.props.siteInfo.id }/order_shipments?query=${convertObjectToBase64(query)}`,
      this.getComplaintsSuccess,
      this.getComplaintsError,
      this.load
    )
    getComplaintsSuccess = payload => this.setState({ pendingComplaintCount: payload.meta.totalCount })
    getComplaintsError = (error) => requestError(handleErrorMsg(error))

    getPackingInProgress = (query) => Get(
      `/sites/${ this.props.siteInfo.id }/marketplace-orders?query=${convertObjectToBase64(query)}`,
      this.getPackingInProgressSuccess,
      this.getPackingInProgressError,
      this.load
    )
    getPackingInProgressSuccess = payload => this.setState({ packingInProgressCount: payload.meta.totalCount })
    getPackingInProgressError = (error) => requestError(handleErrorMsg(error))

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          { ...this.state }
          onChangeHOC={ this.onChangeHOC }
          getPendingMembers={ this.getPendingMembers }
          getPendingCustomers={ this.getPendingCustomers }
          getPendingSellers={ this.getPendingSellers }
          getPendingProducts={ this.getPendingProducts }
          getPendingWithdrawal={ this.getPendingWithdrawal }
          getComplaints={ this.getComplaints }
          getPackingInProgress={ this.getPackingInProgress }
        />
      )
    }
  }
  const mapStateToProps = state => ({
    data: state,
    siteInfo: state.ClientReducer.siteInfo,
    clientInfo: state.ClientReducer.clientInfo,
    permissions: state.ProfileReducer.permissions,
    colors: state.ClientReducer.clientInfo.styles?.colors,
    selectedLanguage: state.ProfileReducer.profile.preferred_language,
    profile: state.ProfileReducer.profile,
    KYCRoleConfig: state.ClientReducer.clientInfo.client_overall_config?.showKYC.roles,
    siteModules: state.ClientReducer.siteModules,
    permissions: state.ProfileReducer.permissions,
    loadingContent: state.LoadingOverlayReducer.loadingContent,
  })
  return connect( mapStateToProps, { addLoadingContent, removeLoadingContent })( WithHOC )
}

export default HOC
